import HmacSHA256 from 'crypto-js/hmac-sha256';
import EncHex from 'crypto-js/enc-hex';

/**
 * 使用 HMAC-SHA256 做对称签名
 * @param message
 * @param secretKey
 */
export function sign(message, secretKey) {
  const hmacStr = HmacSHA256(message, secretKey);
  const hexStr = EncHex.stringify(hmacStr);
  return hexStr.toUpperCase();
}
